import React from 'react'

const Spinner = () => {
  return (
    <div className='w-screen h-screen flex items-center justify-center'>
        <div className='loader '></div>
    </div>
    
  )
}

export default Spinner